import React from "react";
import { Button, Descriptions, Drawer, Space, Tag, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { statusColor } from "./utils";

export default function CatalogItemDetailsDrawer({
  open,
  onClose,
  item,
  title = "Catalog Item",
  onEdit,
}) {
  return (
    <Drawer
      title={title}
      width={560}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2000}
      extra={
        onEdit ? (
          <Button icon={<EditOutlined />} type="primary" onClick={() => onEdit(item)}>
            Edit
          </Button>
        ) : null
      }
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label="ID">{item?.id || "-"}</Descriptions.Item>
          <Descriptions.Item label="Code">{item?.code || "-"}</Descriptions.Item>
          <Descriptions.Item label="Name">{item?.name || "-"}</Descriptions.Item>
          <Descriptions.Item label="Description">
            <Typography.Paragraph style={{ marginBottom: 0, whiteSpace: "pre-wrap" }}>
              {item?.description || "-"}
            </Typography.Paragraph>
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={statusColor(item?.active ? "ACTIVE" : "INACTIVE")}>
              {item?.active ? "ACTIVE" : "INACTIVE"}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      </Space>
    </Drawer>
  );
}

